import script from "./TodaysCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./TodaysCoupons.vue?vue&type=script&setup=true&lang=js"

import "./TodaysCoupons.vue?vue&type=style&index=0&id=01c84c3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c84c3d"]])

export default __exports__